<template>
  <main :class="ns.b()">
    <slot />
  </main>
</template>

<script lang="ts" setup>
import { useNamespace } from '@zoryn/hooks'

defineOptions({
  name: 'ZMain',
})

const ns = useNamespace('main')
</script>
